import React from 'react';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { Row, Col } from 'reactstrap';

import { pickAColor } from 'core/generalFunctions';

/*
props:
viaje
seleccionarChofer
quitarChofer
seleccionarVehiculo
quitarVehiculo
editarViaje
eliminarViaje
reservasViaje
*/

export default class extends React.Component {
  render() {
    const { viaje } = this.props,
      trayectoColor = pickAColor(viaje.get('trayectoId'));
    return (
      <div>
        <MaterialUI.ListItem
          disabled
          className="noMargin"
          primaryText={
            <Row>
              <Col md="2" className="textCenter">
                <p className="fs-20 bolder">
                  {!viaje.get('publico') && <FontAwesome name="users" className="iconInfo" style={{ color: trayectoColor, paddingRight: 5 }} />}
                  {viaje.get('precioBoleto') && <FontAwesome name="usd" className="iconInfo" style={{ color: trayectoColor, paddingRight: 5 }} />}
                  {viaje.get('rutinaId') && <FontAwesome name="calendar" className="iconInfo" style={{ color: trayectoColor, paddingRight: 5 }} />}
                  <FontAwesome name="clock-o" className="fs-20" style={{ color: trayectoColor }} /> {' ' + moment(viaje.get('horario')).format('HH:mm')}
                </p>
              </Col>
              <Col md="7">
                <p className="fs-20 bolder" style={{ color: trayectoColor }}>
                  <FontAwesome name="map" className="fs-20" />{' '}
                  {viaje.getIn(['_trayecto', 'subnombre']) ? viaje.getIn(['_trayecto', 'nombre']) + ' - ' + viaje.getIn(['_trayecto', 'subnombre']) : viaje.getIn(['_trayecto', 'nombre'])}{' '}
                </p>
              </Col>
              <Col md="3">
                <MaterialUI.RaisedButton
                  primary={true}
                  label="Reservas"
                  buttonStyle={{ backgroundColor: trayectoColor }}
                  icon={<FontAwesome className="iconBar white" name="ticket" />}
                  className="fullWidthComponent noPadding"
                  onTouchTap={() => this.props.reservasViaje(viaje.get('id'))}
                />
              </Col>
            </Row>
          }
          secondaryText={
            <Row className="autoHeight">
              <Col md="2" xs="2">
                <Row>
                  <Col md="12" className="textCenter bolder pt-10 fs-20">
                    <span className={viaje.get('cantReservas') >= viaje.get('cantAsientos') ? 'unavailable' : this.props.manana ? 'available bg-2' : 'available'}>
                      <FontAwesome name={viaje.get('cantReservas') > 10 ? 'users' : 'user'} className="fs-20 pr-10" />
                      <span className="fs-20 bolder">
                        {viaje.get('cantReservas') ? viaje.get('cantReservas') : 0} / {viaje.get('cantAsientos')}
                      </span>
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col md="3" xs="3">
                {viaje.get('_vehiculo') ? (
                  <Row>
                    <Col md="6">
                      <Row>
                        <Col md="2">
                          <FontAwesome className="iconBar" name="bus" />
                        </Col>
                        <Col md="9">
                          <p>
                            <span className="title blue">{viaje.getIn(['_vehiculo', 'nombre'])}</span>
                          </p>
                          <p className="bolder p-7"> {viaje.getIn(['_vehiculo', 'patente'])} </p>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="4">
                      <Row>
                        <MaterialUI.RaisedButton
                          secondary={true}
                          icon={<FontAwesome className="iconBar white" name="bus" />}
                          className="fullWidthComponent noPadding"
                          buttonStyle={{ backgroundColor: trayectoColor }}
                          onTouchTap={() => this.props.seleccionarVehiculo(false, viaje.get('id'))}
                        />
                      </Row>
                      <Row className="pt-10">
                        <MaterialUI.RaisedButton
                          secondary={true}
                          icon={<FontAwesome className="iconBar white" name="times" />}
                          className="fullWidthComponent noPadding"
                          onTouchTap={() => this.props.quitarVehiculo(viaje.get('id'))}
                        />
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <MaterialUI.RaisedButton
                    secondary={true}
                    label="Vehiculo"
                    icon={<FontAwesome className="iconBar white" name="bus" />}
                    className="fullWidthComponent noPadding"
                    buttonStyle={{ backgroundColor: trayectoColor }}
                    onTouchTap={() => this.props.seleccionarVehiculo(false, viaje.get('id'))}
                  />
                )}
              </Col>
              <Col md="4" xs="4">
                {viaje.get('_chofer') ? (
                  <Row>
                    <Col md="6">
                      <Row>
                        <Col md="3">
                          <FontAwesome className="iconBar" name="user" />
                        </Col>
                        <Col md="9">
                          <p>
                            <span className="title blue">{viaje.getIn(['_chofer', 'apellido'])}</span>
                          </p>
                          <p>
                            <span className="bolder"> {viaje.getIn(['_chofer', 'nombre'])} </span>
                          </p>
                          <p className="bolder"> {viaje.getIn(['_chofer', 'documento'])} </p>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="4">
                      <Row>
                        <MaterialUI.RaisedButton
                          secondary={true}
                          icon={<FontAwesome className="iconBar white" name="user" />}
                          className="fullWidthComponent noPadding"
                          buttonStyle={{ backgroundColor: trayectoColor }}
                          onTouchTap={() => this.props.seleccionarChofer(false, viaje.get('id'))}
                        />
                      </Row>
                      <Row className="pt-10">
                        <MaterialUI.RaisedButton
                          secondary={true}
                          icon={<FontAwesome className="iconBar white" name="times" />}
                          className="fullWidthComponent noPadding"
                          onTouchTap={() => this.props.quitarChofer(viaje.get('id'))}
                        />
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  viaje.getIn(['_vehiculo', '_chofer']) && (
                    <Row className="pb-10">
                      <MaterialUI.RaisedButton
                        primary={true}
                        label={viaje.getIn(['_vehiculo', '_chofer', 'nombre']) + ' ' + viaje.getIn(['_vehiculo', '_chofer', 'apellido'])}
                        icon={<FontAwesome className="iconBar white" name="user" />}
                        className="fullWidthComponent noPadding"
                        buttonStyle={{ backgroundColor: trayectoColor }}
                        onTouchTap={() => this.props.asignar(viaje.getIn(['_vehiculo', 'choferId']), viaje.get('id'))}
                      />
                    </Row>
                  )
                )}
                {!viaje.get('_chofer') && (
                  <Row>
                    <MaterialUI.RaisedButton
                      secondary={true}
                      label="Chofer"
                      buttonStyle={{ backgroundColor: trayectoColor }}
                      icon={<FontAwesome className="iconBar white" name="user" />}
                      className="fullWidthComponent noPadding"
                      onTouchTap={() => this.props.seleccionarChofer(false, viaje.get('id'))}
                    />
                  </Row>
                )}
              </Col>
              <Col md={{ size: 2, offset: 1 }} xs="2">
                <Row>
                  <MaterialUI.RaisedButton
                    primary={true}
                    label="Editar"
                    buttonStyle={{ backgroundColor: trayectoColor }}
                    icon={<FontAwesome className="iconBar white" name="edit" />}
                    className="fullWidthComponent noPadding"
                    onTouchTap={() => this.props.editarViaje(viaje.get('id'))}
                  />
                </Row>
                <Row className="pt-10">
                  <MaterialUI.RaisedButton
                    secondary={true}
                    label="Eliminar"
                    disabled={viaje.get('cantReservas') != 0}
                    icon={<FontAwesome className={viaje.get('cantReservas') != 0 ? 'iconBar' : 'iconBar white'} name="trash" />}
                    className="fullWidthComponent noPadding"
                    onTouchTap={() => this.props.eliminarViaje(viaje.get('id'))}
                  />
                </Row>
              </Col>
            </Row>
          }
        />
        <MaterialUI.Divider />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/asignacion/components/itemList.js